function getCalculatorElements(calculatorElement) {
  const outputElement = calculatorElement.querySelector(".boa-coverage-calculator__output");
  const volumeElement = calculatorElement.querySelector(".boa-coverage-calculator__volume");
  const piecesElement = calculatorElement.querySelector(".boa-coverage-calculator__pieces");

  if (!outputElement || !volumeElement) return null;

  return { outputElement, volumeElement, piecesElement };
}

function getSingleCoverage(coveragePerUnit, volume, layersRequired) {
  if (!coveragePerUnit || !volume || !layersRequired) return 0;
  return (coveragePerUnit * volume) / layersRequired;
}

function getQuantityInput(calculatorElement) {
  return calculatorElement.closest(".product__blocks")?.querySelector(".quantity__input");
}

function updateCalculator(calculatorElement, elements, singleCoverage, volumeText, quantity) {
  const totalCoverage = quantity * singleCoverage;
  elements.outputElement.textContent = totalCoverage.toFixed(2);
  elements.volumeElement.textContent = volumeText;
  if (elements.piecesElement) {
    elements.piecesElement.textContent = quantity;
  }
  calculatorElement.classList.toggle("hidden", totalCoverage === 0);
}

function renderBoaCoverageCalculator() {
  const calculatorElement = document.getElementById("boa-coverage-calculator");
  if (!calculatorElement) return;

  const elements = getCalculatorElements(calculatorElement);
  if (!elements) return;

  const quantityInput = getQuantityInput(calculatorElement);
  if (!quantityInput) return;

  const { coveragePerUnit, layersRequired, volumeDecimal, volumeText } = calculatorElement.dataset;
  const singleCoverage = getSingleCoverage(Number(coveragePerUnit), Number(volumeDecimal), Number(layersRequired));

  updateCalculator(calculatorElement, elements, singleCoverage, volumeText, Number(quantityInput.value));
}

function onVariantVolumeChange(calculatorElement, quantityInput, input) {
  const volumeDecimal = input.dataset.variantVolume;
  const volumeText = input.dataset.variantTextualVolume?.trim();
  if (!Number(volumeDecimal) || !volumeText) return;

  // product-info.js's re-render swaps only a fixed set of ids, not this element, so its
  // server-rendered volume stays on the page-load variant unless we write the new one back.
  calculatorElement.dataset.volumeDecimal = volumeDecimal;
  calculatorElement.dataset.volumeText = volumeText;

  quantityInput.value = 1;
  renderBoaCoverageCalculator();
}

document.addEventListener("change", (event) => {
  const calculatorElement = document.getElementById("boa-coverage-calculator");
  if (!calculatorElement) return;

  const quantityInput = getQuantityInput(calculatorElement);
  if (!quantityInput) return;

  const input = event.target;

  if (input.matches?.("input[data-variant-textual-volume]")) {
    onVariantVolumeChange(calculatorElement, quantityInput, input);
  } else if (input === quantityInput) {
    renderBoaCoverageCalculator();
  }
});

document.addEventListener("DOMContentLoaded", renderBoaCoverageCalculator);
document.addEventListener("boa-render-product-info-end", renderBoaCoverageCalculator);
